import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "43",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.53 18.106c-.998 0-1.677.83-1.677 1.676v6.93c0 .543.178.953.45 1.225.273.272.683.451 1.226.451h8.941c.544 0 .954-.179 1.226-.45.272-.273.45-.683.45-1.226v-6.93c0-.543-.178-.953-.45-1.225s-.682-.451-1.226-.451zm-2.795 1.676c0-1.389 1.109-2.794 2.794-2.794h8.941c.798 0 1.506.269 2.016.779s.779 1.218.779 2.015v6.93c0 .797-.269 1.506-.779 2.015s-1.218.779-2.016.779h-8.94c-.798 0-1.506-.268-2.016-.779-.51-.51-.779-1.218-.779-2.015z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19 11.624c-1.703 0-3.241 1.538-3.241 3.241v2.682a.559.559 0 1 1-1.118 0v-2.682c0-2.32 2.039-4.359 4.359-4.359s4.359 2.039 4.359 4.36v2.682a.559.559 0 1 1-1.118 0v-2.683c0-1.703-1.538-3.241-3.241-3.241",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.15 2.49c-.888-.354-1.664-.313-2.215-.037q-.06.03-.122.052L5.942 6.761c-2.223.74-3.707 2.77-3.707 5.198v10.953c0 3.786.928 6.351 3.167 8.768 2.318 2.502 6.067 4.88 11.883 8.125 1.016.498 2.406.5 3.423.003 5.822-3.36 9.572-5.736 11.894-8.216 2.237-2.39 3.163-4.897 3.163-8.68V11.959c0-2.227-1.505-4.465-3.707-5.199l-.023-.008-11.847-4.247zm.81-2.083C19.64-.115 18.218-.16 17 .422L5.222 4.644C2.087 5.694 0 8.58 0 11.959v10.953c0 4.26 1.084 7.396 3.762 10.287 2.598 2.804 6.665 5.34 12.458 8.571l.045.024c1.656.828 3.814.828 5.47 0q.03-.014.059-.032c5.783-3.336 9.848-5.873 12.44-8.642C36.914 30.257 38 27.176 38 22.912V11.959c0-3.134-2.067-6.257-5.222-7.315z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }